import Service, { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import { gt, readOnly, equal } from '@ember/object/computed';
import ApiService from 'cio/services/api';
import MessageLimitModel from 'cio/models/message-limit';
import DS from 'ember-data';
import ApiErrorsService from './api-errors';
import AccountService from './account';

export default class MessageSettingsService extends Service {
  @service api!: ApiService;
  @service apiErrors!: ApiErrorsService;
  @service store!: DS.Store;
  @service account!: AccountService;

  messageLimit: MessageLimitModel | null = null;

  @equal('loadURLParamsCredential.last.value', true) areURLParamsEnabled!: boolean;
  @equal('loadURLParamsCredential.last.value', false) areURLParamsDisabled!: boolean;
  @readOnly('loadURLParamsCredential.isRunning') isURLParamsCredentialLoading!: boolean;

  @gt('messageLimit.count', 0) isMessagingLimitEnabled!: boolean;
  @readOnly('loadMessagingLimit.isRunning') isMessagingLimitLoading!: boolean;

  loadURLParamsCredential = task({ drop: true }, async () => {
    if (!this.account.isJourneysAvailable) {
      return;
    }

    try {
      await this.api.request('credentials/url_params', {
        ignoreErrors: true,
        includeStatus: true,
      });

      return true;
    } catch (e) {
      if (e.status === '404') {
        return false;
      }

      return undefined;
    }
  });

  enableURLParams = task({ drop: true }, async () => {
    if (!this.account.isJourneysAvailable) {
      return;
    }

    await this.api.put('credentials/url_params', { data: {} });
    await this.loadURLParamsCredential.perform();
  });

  disableURLParams = task({ drop: true }, async () => {
    if (!this.account.isJourneysAvailable) {
      return;
    }

    await this.api.delete('credentials/url_params');
    await this.loadURLParamsCredential.perform();
  });

  loadMessagingLimit = task(async () => {
    if (!this.account.isJourneysAvailable) {
      return;
    }

    try {
      let limits = await this.store.findRecord('message-limit', 'current');
      this.set('messageLimit', limits);
    } catch (e) {
      this.apiErrors.report(e);
    }
  });
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    'message-settings': MessageSettingsService;
  }
}
